import { Modal } from 'components/common';
import PropType from 'prop-types';
import React from 'react';
import {
  PayPalScriptProvider,
  PayPalButtons,
  FUNDING
} from '@paypal/react-paypal-js';
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import firebase from '../../../firebase/firebase';

const PaypalModal = ({ modal, selectedPlan, userId }) => {
  const { t } = useTranslation();
  const currency = firebase.clientLocation === 'Italia' ? 'EUR' : 'CHF';

  const createPayPalPayment = async () => {
    const amount =
      firebase.clientLocation === 'Italia'
        ? selectedPlan.priceEur
        : selectedPlan.priceChf;
    return firebase.createPaypalOrder(currency, amount, userId);
  };
  const onApprove = async (data) => {
    modal.onCloseModal();
    await firebase.capturePaypalOrder(data, userId, selectedPlan);
    window.location.href = '/account';
  };

  return (
    <Modal isOpen={modal.isOpenModal} onRequestClose={modal.onCloseModal}>
      <div className="text-center padding-l">
        <h4>Pricing: {selectedPlan.name}</h4>
        <p>
          {`${t('planTablePrice')}: `}
          {firebase.clientLocation === 'Italia'
            ? selectedPlan.priceEur
            : selectedPlan.priceChf}{' '}
          {firebase.clientCurrency}
        </p>
        <span>*{t('choosePaymentMethodPricingMessage')}</span>
        <br />
        <br />
        <PayPalScriptProvider
          options={{
            'client-id':
              'AeQfbKouwv-65pwf3pKIh2dWwaMLTqGoP60S7BgwyRbiAXC7PceQ04olYSDCLIZYcKHCZDTgc8Dw1KX0',
            currency
          }}
        >
          <PayPalButtons
            style={{
              color: 'gold',
              shape: 'rect',
              label: 'pay',
              height: 50
            }}
            fundingSource={FUNDING.PAYPAL}
            createOrder={createPayPalPayment}
            onApprove={onApprove}
          />
        </PayPalScriptProvider>
      </div>
      <button
        className="modal-close-button button button-border button-border-gray button-small"
        onClick={modal.onCloseModal}
        type="button"
      >
        <CloseOutlined />
      </button>
    </Modal>
  );
};

PaypalModal.propTypes = {
  selectedPlan: PropType.shape({
    priceEur: PropType.number,
    priceChf: PropType.number,
    name: PropType.string
  }).isRequired,
  modal: PropType.shape({
    onCloseModal: PropType.func,
    isOpenModal: PropType.bool
  }).isRequired,
  userId: PropType.string.isRequired
};

export default PaypalModal;
